import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { showNestedModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { useState } from "react"
import Button from "../../shared/button/Button"
import InputText from "../../shared/input/new/InputText"
import { addKayitliLoad } from "../../../features/kayit/kayitSlice"
import { toast } from "react-toastify"
import { buildRegisteredLoadPayload } from "../../../helper/load/registeredLoadPayload"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .img-kamyonoo{
            width: 80px;
            height: 40px;
            margin-bottom: 20px;
        }

        h2{
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-lg);
            margin-bottom: 30px;
        }

        p{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            margin-bottom: 30px;

        }

        .btn-grp{
            margin-top: 30px;
            width: 80%;
            display: flex;
            justify-content: space-between;
        }           
    }
`

const AddLoadYuklemeSecenekleriForKayitModal = () => {

    const dispatch = useDispatch()
    const [text, setText ] = useState("")
    const activeItem = {
        id:1,
        text: "Herkese Yayınla",
    }

    const {route, aracData, paymentData, yukData, paketlemeData, routeDistance} = useSelector(state => state.addLoad)
    const {isLoadingAddKayitliLoad} = useSelector(state => state.kayit)

    const handleClick = () => {
        if (isLoadingAddKayitliLoad) return

        const saveLoadName = text.trim()
        if (!saveLoadName) {
            toast.error("Lütfen kayıtlı yük için bir isim giriniz.")
            return
        }

        const data = buildRegisteredLoadPayload({
            route,
            aracData,
            paymentData,
            yukData,
            paketlemeData,
            routeDistance,
            saveLoadName,
            publishingTypeId: activeItem.id,
        })

        dispatch(addKayitliLoad(data))
    }

  return (
    <Container onClick={()=> dispatch(showNestedModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <h2>Kayıtlı Yüklere Eklemek İçin Bir İsim Giriniz</h2>
            <InputText data={text} setData={(e) => setText(e.target.value)} labelText="Kayıt Adı" inputWidth={"80%"} isRequired={true} name={"yukKaydiIsmi"}/>
            <div className="btn-grp">
                <Button handleClick={handleClick} text={isLoadingAddKayitliLoad ? "Kaydediliyor..." : "Kaydet"} width="45%" background={"#E85446"} />
                <Button handleClick={() => {dispatch(showNestedModal(null));}} text={"Çıkış"} width="45%" background={"#E85446"} />
            </div>
        </div>
    </Container>
  )
}

export default AddLoadYuklemeSecenekleriForKayitModal
